/** Must match backend/src/constants/patchingGroups.ts group names (exact match). */
export const PATCHING_GROUP_NAMES = ['Windows Patching', 'Linux Patching'] as const;

export const ALL_PATCHING_GROUP_NAMES = new Set<string>(PATCHING_GROUP_NAMES);

/** Effort groups shown only for engagements with Windows or Linux patching configured. */
export const PATCHING_EFFORT_GROUP_NAMES = [
  'L2 Patching Efforts',
  'L3 Patching Efforts'
] as const;

export const ALL_PATCHING_EFFORT_GROUP_NAMES = new Set<string>(PATCHING_EFFORT_GROUP_NAMES);

export function isPatchingEffortGroupName(groupName: string): boolean {
  return ALL_PATCHING_EFFORT_GROUP_NAMES.has(groupName);
}

export function isPatchingGroupName(groupName: string): boolean {
  return ALL_PATCHING_GROUP_NAMES.has(groupName);
}

const L1_SUPPORT_GROUP = 'L1 Support Engineer';

/** Rows that belong in Resource Charges (excludes patching groups; optional L1 for Sphera). */
export function isResourceChargeExportRow(
  groupName: string,
  options?: { excludeL1ForSphera?: boolean }
): boolean {
  if (isPatchingGroupName(groupName)) {
    return false;
  }
  if (options?.excludeL1ForSphera && groupName === L1_SUPPORT_GROUP) {
    return false;
  }
  return true;
}
